import classNames from 'classnames';

function IntroSlideGraphicShapes({}) {
  return (
    <svg
      className={classNames('-mt-[100px]', 'dk:mt-0')}
      width='100%'
      viewBox='0 0 390 308'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M143.79 86C143.79 96.2173 135.107 104.5 124.395 104.5C113.684 104.5 105 96.2173 105 86C105 75.7827 113.684 67.5 124.395 67.5C135.107 67.5 143.79 75.7827 143.79 86Z'
        fill='#FFBB53'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M181.742 283.83C197.566 283.83 210.394 271.594 210.394 256.5C210.394 241.406 197.566 229.17 181.742 229.17C165.918 229.17 153.09 241.406 153.09 256.5C153.09 271.594 165.918 283.83 181.742 283.83ZM181.742 292.5C202.586 292.5 219.484 276.382 219.484 256.5C219.484 236.618 202.586 220.5 181.742 220.5C160.898 220.5 144 236.618 144 256.5C144 276.382 160.898 292.5 181.742 292.5Z'
        fill='#E04E4E'
      />
      <path
        d='M0 256.5C30.3757 256.5 55 233.219 55 204.5C55 175.781 30.3757 152.5 9.09197e-06 152.5L0 256.5Z'
        fill='#FF7236'
      />
      <path
        d='M390.156 96.4187C344.539 101.248 308.998 139.844 308.998 186.741C308.998 233.637 344.539 272.233 390.156 277.062V306.001C328.601 301.076 280.184 249.562 280.184 186.741C280.184 123.919 328.601 72.4052 390.156 67.4805V96.4187Z'
        fill='#8348CF'
      />
    </svg>
  );
}

export default IntroSlideGraphicShapes;
